<!--
 * @FileDescription: 退款记录对话框
 * @Author: 陈文景
 * @Date: 2022-11-07 18:11:51
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="Refund Record" :visible.sync="visible" :width="`${width}px`" :before-close="close">
    <template v-if="records.length">
      <RefundRecordItem v-for="item in records" :key="item.refundId" :data="item" />
    </template>

    <div v-else class="not-data">
      <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
      <div class="tips-text">No Record</div>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
import RefundRecordItem from './RefundRecordItem.vue'

export default {
  components: {
    RefundRecordItem
  },
  data() {
    return {
      width: 650,
      visible: false,

      records: []
    }
  },
  methods: {
    /**
     * API 获取订单退款记录
     *
     * @param {Number} kkOrderId
     */
    async getOrderRefundRecord(kkOrderId) {
      let { data } = await API.getOrderRefundRecord(kkOrderId)
      this.records = data || []
    },

    /**
     * 显示对话框
     *
     * @param {Number} kkOrderId
     */
    show(kkOrderId) {
      this.visible = true
      this.getOrderRefundRecord(kkOrderId)
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.records = []
    }
  }
}
</script>

<style lang="scss" scoped>
.not-data {
  text-align: center;
  .tips-text {
    margin-top: 20px;
  }
}
</style>
